// extracted by mini-css-extract-plugin
export var avatarContainer = "_h5-0";
export var avatarTypingWave = "_h5-i";
export var gray = "_h5-f";
export var green = "_h5-c";
export var icon = "_h5-9";
export var image = "_h5-1";
export var lg = "_h5-6";
export var md = "_h5-5";
export var presenceDot = "_h5-b";
export var red = "_h5-d";
export var sm = "_h5-4";
export var status = "_h5-a";
export var typingDot = "_h5-h";
export var typingPill = "_h5-g";
export var xl = "_h5-7";
export var xs = "_h5-3";
export var xxl = "_h5-8";
export var xxs = "_h5-2";
export var yellow = "_h5-e";